import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import "./style.scss";
import useBreakpoint from "widgets/Onboarding/hooks/useBreakpoint";
import FormHelperText from "components/Form/components/FormHelperText";
import { useFormContext } from "react-hook-form";
import useLanguageProvider from "components/LanguageProvider/hooks/useLanguageProvider";
import FormSubtext from "../FormSubtext";
const CardSelect = ({ classes, error, id, label, name, options, subtext, dataTestId, }) => {
    const { translate: t } = useLanguageProvider();
    const { setValue, watch } = useFormContext();
    const { size } = useBreakpoint();
    const selected = watch(name);
    const updateSelect = (value) => {
        setValue(name, value, { shouldValidate: true });
    };
    const Label = size < 600 ? "h4" : "h3";
    return (_jsxs(_Fragment, { children: [_jsx("label", { htmlFor: id !== null && id !== void 0 ? id : name, children: label }), subtext && _jsx(FormSubtext, { text: subtext }), _jsx("div", { className: `card-select ${classes}`, "data-testid": dataTestId, children: options === null || options === void 0 ? void 0 : options.map((option) => (_jsx("div", { id: `cardSelect_${option.value}`, tabIndex: 0, role: "button", className: `card ${selected === option.value ? "selected" : ""}`, onClick: () => updateSelect(option.value), onKeyDown: (e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            updateSelect(option.value);
                        }
                    }, children: _jsx("div", { className: "card-contents", children: _jsxs("div", { className: "title", children: [_jsx("div", { className: "card-icon", children: option.icon && _jsx(option.icon, { size: size < 600 ? 30 : 45 }) }), _jsx(Label, { children: t(option.label) })] }) }) }, option.value))) }), error && _jsx(FormHelperText, { message: error.message })] }));
};
export default CardSelect;
